/* tslint:disable */
/* eslint-disable */
/**
 * resident-resources
 * resident-resources
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TaskExtensionTemplateDefaultAnswerOptionsInner
 */
export interface TaskExtensionTemplateDefaultAnswerOptionsInner {
    /**
     * 
     * @type {string}
     * @memberof TaskExtensionTemplateDefaultAnswerOptionsInner
     */
    value: string;
}

/**
 * Check if a given object implements the TaskExtensionTemplateDefaultAnswerOptionsInner interface.
 */
export function instanceOfTaskExtensionTemplateDefaultAnswerOptionsInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "value" in value;

    return isInstance;
}

export function TaskExtensionTemplateDefaultAnswerOptionsInnerFromJSON(json: any): TaskExtensionTemplateDefaultAnswerOptionsInner {
    return TaskExtensionTemplateDefaultAnswerOptionsInnerFromJSONTyped(json, false);
}

export function TaskExtensionTemplateDefaultAnswerOptionsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskExtensionTemplateDefaultAnswerOptionsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': json['value'],
    };
}

export function TaskExtensionTemplateDefaultAnswerOptionsInnerToJSON(value?: TaskExtensionTemplateDefaultAnswerOptionsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value,
    };
}

